<template>
  <div class="w-full max-w-3xl py-20 bg-white mb-100">
    <div>
      <h2 class="mt-5 mb-15">
        {{
          activeAutoReward
            ? $t('rewards.automatic_rewards.selection.title_edit')
            : $t('rewards.automatic_rewards.title')
        }}
      </h2>
      <p class="text md:pr-60">
        {{ $t('rewards.automatic_rewards.selection.description') }}
      </p>
      <div class="flex justify-end">
        <AZSorter @sort="isSortedAsc = !isSortedAsc" />
      </div>
      <GiftCardSelector
        v-for="(reward, index) in sortedRewards"
        :key="`${index}${reward.name}`"
        :reward="reward"
        :autoReward="true"
      />
    </div>

    <!-- footer -->
    <div
      class="fixed bottom-0 right-0 w-screen bg-white py-25 px-40 flex justify-between items-center border-t"
      role="region"
    >
      <HMButton color="white" class="w-200" outlined @click="$router.push('/rewards')">
        {{ $t('common.cancel_btn') }}
      </HMButton>
      <HMButton
        class="w-200"
        :disabled="!selectedAutoReward.id"
        @click="$router.push('/rewards/auto/confirm')"
      >{{ $t('common.next_btn') }}
      </HMButton>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AZSorter from '../../common/AZSorter'
import _orderBy from 'lodash/orderBy'
import _toLower from 'lodash/toLower'
import GiftCardSelector from './GiftCardSelector'

export default {
  name: 'AutoRewardsSelection',
  components: { AZSorter, GiftCardSelector },
  data() {
    return {
      isSortedAsc: true,
    }
  },
  computed: {
    ...mapGetters('rewards', [
      'activeAutoReward',
      'groupedAutoRewards',
      'selectedAutoReward',
    ]),
    sortedRewards() {
      const sortOrder = this.isSortedAsc ? 'asc' : 'desc'
      return _orderBy(
        this.groupedAutoRewards,
        [(reward) => _toLower(reward.name)],
        [sortOrder]
      )
    },
  },
}
</script>
